export default function EmailInputIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="2"
        width="14"
        height="12"
        rx="2"
        fill="var(--tertiary-color)"
        fillOpacity="0.5"
      />
      <path
        d="M1 4C1 2.89543 1.89543 2 3 2L13 2C14.1046 2 15 2.89543 15 4L15 5L8 9L1 5L1 4Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
